import { latestArticles } from './homeData';

export const allArticles = [
  ...latestArticles,
  {
    id: 'article-009',
    title: '知名导演片场耍大牌被录音，剧组工作人员集体吐槽',
    summary: '一段疑似片场录音曝光，某知名导演对演员和工作人员言语粗暴，多位匿名剧组人员在线证实。',
    tag: '独家',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=A%20film%20director%20chair%20on%20an%20empty%20movie%20set%20with%20dramatic%20lighting%2C%20megaphone%20on%20the%20seat%2C%20dark%20atmosphere%2C%20behind%20the%20scenes%20scandal%20concept%2C%20cinematic%20composition%2C%20editorial%20photography&width=800&height=600&seq=article-gossip-09&orientation=landscape',
    category: '明星黑料',
    date: '2026-07-02',
  },
  {
    id: 'article-010',
    title: '百万粉穿搭博主被曝穿假货，正品对比图打脸太狠',
    summary: '网友晒出同款正品细节对比，揭露某穿搭博主长期穿着高仿假货冒充正品，人设彻底崩塌。',
    tag: '实锤',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20over%20a%20luxury%20bag%20showing%20stitching%20details%2C%20comparison%20concept%2C%20authentic%20versus%20fake%2C%20dark%20luxurious%20background%2C%20dramatic%20lighting%2C%20editorial%20photography%20style&width=800&height=600&seq=article-gossip-10&orientation=landscape',
    category: '博主反差',
    date: '2026-07-01',
  },
  {
    id: 'article-011',
    title: '户外主播擅闯军事禁区直播，警方介入调查',
    summary: '某户外探险主播为博流量闯入军事禁区进行直播，画面中清晰可见禁入标识，已被警方传唤。',
    tag: '热议',
    tagColor: 'bg-accent-500',
    image: 'https://readdy.ai/api/search-image?query=A%20warning%20sign%20on%20a%20fence%20in%20a%20remote%20area%20with%20dramatic%20cloudy%20sky%2C%20restricted%20area%20concept%2C%20tense%20atmosphere%2C%20documentary%20photography%20style%2C%20moody%20lighting&width=800&height=600&seq=article-gossip-11&orientation=landscape',
    category: '网红塌房',
    date: '2026-07-01',
  },
  {
    id: 'article-012',
    title: '某男团成员夜店与粉丝冲突视频曝光，经纪公司发声明致歉',
    summary: '监控视频显示该成员在夜店与粉丝发生肢体冲突，视频在社交平台迅速传播，粉丝后援会宣布解散。',
    tag: '实锤',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=A%20blurry%20nightclub%20scene%20with%20neon%20lights%2C%20crowded%20dance%20floor%2C%20dramatic%20purple%20and%20pink%20lighting%2C%20chaotic%20atmosphere%2C%20nightlife%20scandal%20concept%2C%20editorial%20photography&width=800&height=600&seq=article-gossip-12&orientation=landscape',
    category: '明星黑料',
    date: '2026-06-30',
  },
  {
    id: 'article-013',
    title: '带货主播直播间情绪失控大哭，疑似团队内部矛盾激化',
    summary: '某头部带货主播在直播过程中突然崩溃大哭，声称"受够了"，随后匆匆下播，疑似与MCN机构产生严重分歧。',
    tag: '热议',
    tagColor: 'bg-accent-500',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20streaming%20setup%20with%20ring%20light%20turned%20off%2C%20abandoned%20microphone%20on%20desk%2C%20emotional%20breakdown%20concept%2C%20dramatic%20shadow%20play%2C%20behind%20the%20scenes%20streamer%20life%2C%20moody%20atmosphere&width=800&height=600&seq=article-gossip-13&orientation=landscape',
    category: '网红塌房',
    date: '2026-06-30',
  },
  {
    id: 'article-014',
    title: '知识博主学术背景存疑，知网查重发现多篇文章涉嫌抄袭',
    summary: '网友使用知网查重工具检测该博主的付费课程内容，发现与多篇已发表论文高度重合，涉嫌严重学术不端。',
    tag: '独家',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=A%20stack%20of%20academic%20papers%20with%20red%20markings%20and%20highlighted%20text%20under%20a%20desk%20lamp%2C%20plagiarism%20detection%20concept%2C%20dark%20wooden%20desk%2C%20dramatic%20focused%20lighting%2C%20editorial%20photography&width=800&height=600&seq=article-gossip-14&orientation=landscape',
    category: '博主反差',
    date: '2026-06-29',
  },
  {
    id: 'article-015',
    title: '知名歌手演唱会假唱被技术博主实锤，波形图对比铁证如山',
    summary: '技术博主用专业音频软件分析演唱会录音，发现多个高难度唱段波形与录音室版本完全一致，引发全网热议。',
    tag: '实锤',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=A%20microphone%20on%20a%20dark%20stage%20with%20sound%20wave%20visualization%20in%20the%20background%2C%20concert%20performance%20concept%2C%20dramatic%20spotlight%2C%20music%20industry%20scandal%2C%20editorial%20photography%20style&width=800&height=600&seq=article-gossip-15&orientation=landscape',
    category: '明星黑料',
    date: '2026-06-29',
  },
  {
    id: 'article-016',
    title: '健身博主私教课涉嫌虚假宣传，学员集体维权要求退款',
    summary: '超过200名学员联合投诉某健身博主，称其承诺的"三个月练出马甲线"课程效果与宣传严重不符，已向消协举报。',
    tag: '热议',
    tagColor: 'bg-accent-500',
    image: 'https://readdy.ai/api/search-image?query=A%20gym%20with%20dumbbells%20and%20kettlebells%20scattered%20on%20the%20floor%2C%20empty%20and%20abandoned%2C%20dramatic%20overhead%20lighting%2C%20fitness%20scam%20concept%2C%20dark%20moody%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=article-gossip-16&orientation=landscape',
    category: '博主反差',
    date: '2026-06-28',
  },
];

export const categoryMap: Record<string, string> = {
  'mingxing-heiliao': '明星黑料',
  'wanghong-tafang': '网红塌房',
  'bozhu-fancha': '博主反差',
  'meiri-baoliao': '每日爆料',
  all: '全部文章',
};

export const categoryIcons: Record<string, string> = {
  'mingxing-heiliao': 'ri-star-line',
  'wanghong-tafang': 'ri-collapse-diagonal-line',
  'bozhu-fancha': 'ri-contrast-2-line',
  'meiri-baoliao': 'ri-fire-line',
  all: 'ri-global-line',
};

export const categoryDescriptions: Record<string, string> = {
  'mingxing-heiliao': '娱乐圈明星不为人知的秘密，从顶流到十八线，只有你想不到，没有我们挖不到的黑料。',
  'wanghong-tafang': '短视频网红、带货主播、游戏主播的翻车现场全记录，塌房速度比翻书还快。',
  'bozhu-fancha': '人前光鲜亮丽、人设完美的博主背后，反差巨大的真实生活曝光。',
  'meiri-baoliao': '每日最新最热的网络爆料汇总，不错过任何一个值得关注的网络热门事件。',
  all: '吃瓜网官网全部爆料文章汇总，涵盖明星黑料、网红塌房、博主反差等所有分类。',
};

export function getArticlesByCategory(slug: string) {
  if (slug === 'all' || slug === 'meiri-baoliao') {
    return allArticles;
  }
  const categoryName = categoryMap[slug];
  if (!categoryName) return [];
  return allArticles.filter((a) => a.category === categoryName);
}